/** Custom element for Product form step */
class ProductFormStep extends HTMLElement {
	constructor() {
		super();
		this.subscription_products = [
			6800856776770, 6800852877378, 6800862216258, 6861096812610,
			6800861069378, 6800859037762,
		];
		this.form = this.querySelector("form");
		this.form.querySelector("[name=id]").disabled = false;

		// confirmation modal
		this.confirmModalId = this.getAttribute("data-modal-confirmation");

		this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
		this.cart =
			document.querySelector("cart-notification") ||
			document.querySelector("cart-drawer");
		this.submitButton = this.querySelector('[type="submit"]');

		this.closestvariantSelectsOpt = "";
		if (document.querySelector("cart-drawer"))
			this.submitButton.setAttribute("aria-haspopup", "dialog");
	}

	//on form submit handler
	async onSubmitHandler(evt) {
		evt.preventDefault();
		if (this.submitButton.getAttribute("aria-disabled") === "true") return;

		//dog name hide
		var dogName = document.querySelector(
			".last-step-container #your-dogs-name"
		);
		if (!this.quizActButton && dogName && dogName.value == "") {
			var dogNameError = document.querySelectorAll(
				".last-step-container  .dogName_error"
			);
			dogNameError.length > 0 &&
				dogNameError.forEach(function (nameError) {
					nameError.style.display = "block";
				});

			return;
		}

		var dogNameError = document.querySelectorAll(
			".last-step-container  .dogName_error"
		);
		dogNameError.length > 0 &&
			dogNameError.forEach(function (nameError) {
				nameError.style.display = "none";
			});

		//error
		this.handleErrorMessage();
		var is_add_another_dog = $(".product-form__submit.button:visible").attr(
			"add-another-dog"
		);

		//add another dog
		if (!is_add_another_dog) {
			this.submitButton.setAttribute("aria-disabled", true);
			this.submitButton.classList.add("loading");
			this.querySelector(".loading-overlay__spinner").classList.remove(
				"hidden"
			);
		} else {
			$(".add_another_dog").attr("aria-disabled", true);
			$(".add_another_dog").addClass("loading");
			$(".add_another_dog .loading-overlay__spinner").removeClass(
				"hidden"
			);
		}

		const config = fetchConfig("javascript");
		config.headers["X-Requested-With"] = "XMLHttpRequest";
		delete config.headers["Content-Type"];

		const formData = new FormData(this.form);
		if (this.cart) {
			formData.append(
				"sections",
				this.cart.getSectionsToRender().map((section) => section.id)
			);
			formData.append("sections_url", window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		}

		// Custom Code for remove property when only main diet plan is selected
		const mainDietPlanIds = [
			"6800859037762",
			"6800861069378",
			"6800862216258",
			"6800852877378",
			"6800856776770",
			"7521325678658",
			"7521325482050",
		];
		const productId = formData.get("product-id");

		if (mainDietPlanIds.includes(productId)) {
			// If it exists, remove the Custom Plan property from formData
			formData.delete("properties[Custom Plan]");
		}

		config.body = formData;
		let product_id = 0;
		for (var pair of formData.entries()) {
			if (pair[0] == "product-id") {
				product_id = pair[1];
				break;
			}
		}
		//check if product id matches with the subscription products array
		var prodValidaton = {
			status: true,
			message: "",
		};
		if (this.subscription_products.includes(parseInt(product_id))) {
			prodValidaton = this.checkForSellingPlan(formData);
		}

		var _this = this;

		// var confirmModal = document.querySelector("add-more-confirmation");
		var confirmModal = document.querySelector("you-may-also-like-popup");
		var OpenCartDrawer = true;
		if (is_add_another_dog) {
			confirmModal = false;
			OpenCartDrawer = false;
		}
		// return false;
		console.log(prodValidaton);
		console.log(routes.cart_add_url);
		if (prodValidaton.status) {
			await fetch("/discount/FIRSTTIMEUSER20");
			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						this.handleErrorMessage(response.description);

						const soldOutMessage =
							this.submitButton.querySelector(
								".sold-out-message"
							);

						//if soldOutMessage is avaible then run rest code otherwise return
						if (!soldOutMessage) return;
						this.submitButton.setAttribute("aria-disabled", true);
						this.submitButton
							.querySelector("span")
							.classList.add("hidden");
						soldOutMessage.classList.remove("hidden");
						this.error = true;
						return;
					} else if (!this.cart) {
						window.location = window.routes.cart_url;
						return;
					}

					this.error = false;
					const quickAddModal = this.closest("quick-add-modal");
					if (quickAddModal) {
						document.body.addEventListener(
							"modalClosed",
							() => {
								setTimeout(() => {
									this.cart.renderContents(response);
								});
							},
							{ once: true }
						);
						quickAddModal.hide(true);
					} else {
						if (this.confirmModalId && confirmModal) {
							this.cart.onlyRenderContents(response);
							// $("#MainContent").hide();
							// $(".gotMilkAddonMain").show();
							// $('.header__icon--cart').click();
							document.querySelector("cart-drawer").open();

							// if (response.handle != 'quiz-product') {
							//   $(".add_gm_to_every_order").show();
							// }
						} else {
							if (OpenCartDrawer) {
								this.cart.renderContents(response);
							} else {
								location.href = "/pages/menu";
							}
						}
					}
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					this.submitButton.classList.remove("loading");
					if (this.cart && this.cart.classList.contains("is-empty"))
						this.cart.classList.remove("is-empty");
					if (!this.error)
						this.submitButton.removeAttribute("aria-disabled");
					this.querySelector(
						".loading-overlay__spinner"
					).classList.add("hidden");

					//add upsell form
					var upsellForm = document.querySelector(
						'product-form.upsell_form [type="submit"]'
					);
					if (
						upsellForm &&
						document.querySelector(
							'.custom-selected-diet .variety-box[diet-type="bag"]'
						)
					) {
						upsellForm.click();
					}
				});
		} else {
			alert(prodValidaton.message);
			window.location.reload();
		}
	}

	getCookie(name) {
		const cookies = document.cookie.split("; ");
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].split("=");
			if (cookie[0] === name) {
				return decodeURIComponent(cookie[1]);
			}
		}
		return null; // Return null if the cookie is not found
	}

	//function to check if selling plan is set in form data
	checkForSellingPlan(formData) {
		let status = false;
		for (var pair of formData.entries()) {
			if (pair[0] == "selling_plan" && pair[1].trim() != "") {
				status = true;
			}
		}
		if (status) {
			return { status: status, message: "" };
		} else {
			return {
				status: status,
				message:
					"Something went wrong please reload the page and try again.",
			};
		}
	}

	handleErrorMessage(errorMessage = false) {
		this.errorMessageWrapper =
			this.errorMessageWrapper ||
			this.querySelector(".product-form__error-message-wrapper");
		if (!this.errorMessageWrapper) return;
		this.errorMessage =
			this.errorMessage ||
			this.errorMessageWrapper.querySelector(
				".product-form__error-message"
			);

		this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

		if (errorMessage) {
			this.errorMessage.textContent = errorMessage;
		}
	}
}
customElements.define("product-step-form", ProductFormStep);

var alreadyAdded = false;

/**custom Elements for variant selection */
class VariantSelectsOpt extends HTMLElement {
	constructor() {
		super();
		this.selectWeekOption = this.querySelector(
			'.select [name="options[Delivery Options]"], .select [name*="Delivery"]'
		);
		this.selectWeekOptionButton = this.querySelector(
			".delivery-button-option"
		);
		this.prodSection = this.closest("[target-prod]");
		//if parent element available
		if (this.prodSection) {
			this.initLoad();
			this.addEventListener("change", this.onVariantChange.bind(this));
			this.selectWeekOptionButton.addEventListener(
				"click",
				this.changeSelected.bind(this)
			);
			this.dogNameField = this.querySelector("#your-dogs-name");
			this.dogNameField &&
				this.dogNameField.addEventListener(
					"keydown",
					this.onKeyDownEvent.bind(this)
				);
		}
	}

	//initial load
	initLoad() {
		this.updateOptions();

		//inser week option
		this.insertWeekOption();

		//update options after week option update
		this.updateOptions();
		this.updateMasterId();

		this.updateRechargeOptions();
	}

	//update dog names
	updateDogName(value) {
		var dogNameLabel = document.querySelectorAll('[data-name="dog-name"]');
		if (dogNameLabel.length > 0) {
			dogNameLabel.forEach(function (label) {
				if (value.length > 0) {
					label.innerHTML = value;
				} else {
					label.innerHTML = "[dog’s name]";
				}
			});
		}
	}

	onKeyDownEvent(event) {
		var _this = this;
		setTimeout(function () {
			var pageNameField = document.querySelectorAll(
				".product-meal-plan-right #your-dogs-name"
			);
			pageNameField.length > 0 &&
				pageNameField.forEach(function (field) {
					field.value = event.target.value;
				});

			_this.updateDogName(event.target.value);

			var newPdpSte = document.querySelector("new-pdp-step-page");
			if (newPdpSte) {
				newPdpSte.updateProperties();
			}
		}, 200);
	}

	onVariantChange(event) {
		console.log("variant change");
		this.updateOptions();

		//update week option
		if (
			event.target &&
			event.target.name &&
			event.target.name.includes("eight")
		) {
			this.insertWeekOption();
		}

		//update options after week option update
		this.updateOptions();
		this.updateMasterId();

		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.removeErrorMessage();

		if (!this.currentVariant) {
			this.toggleAddButton(true, "", true);
			this.setUnavailable();
		} else {
			this.updateVariantInput();
			this.renderProductInfo();
		}

		this.updateRechargeOptions();

		document.dispatchEvent(
			new CustomEvent("afterVariantChange", {
				bubbles: true,
				detail: { event },
			})
		);
	}

	removeClass(closestVariantSelector) {
		closestVariantSelector
			.querySelectorAll(".delivery-button")
			.forEach((el, index) => {
				el.className = "delivery-button";
			});
	}

	changeSelected(event) {
		$(".delivery-button:visible span").removeClass("selected-option");
		var target = event.target;
		if (!target.dataset.deliveryValue) {
			target = target.closest(".delivery-button");
		}

		// Check if target exists and has the expected class
		if (!target || !target.classList.contains("delivery-button")) {
			return false;
		}

		const targetClassList = target.className;
		if (targetClassList.indexOf("selected-option") > -1) {
			return false;
		}

		const closestVariantSelector = target.closest("variant-selects-opt");

		// Add null check for closestVariantSelector
		if (!closestVariantSelector) {
			return false;
		}

		this.closestvariantSelectsOpt = closestVariantSelector;
		this.removeClass(closestVariantSelector);
		target.classList.add("selected-option");

		if ($(".delivery-button:visible span").hasClass("selected-option")) {
			$(".delivery-button:visible").removeClass("selected-option");
			$(".delivery-button:visible .selected-option")
				.parents(".delivery-button")
				.addClass("selected-option");
		}

		var $select = closestVariantSelector.querySelector(
			'[name="options[Delivery Options]"]'
		);
		if (!$select) {
			$select = closestVariantSelector.querySelector(
				'[name="options[Delivery Time]"]'
			);
		}

		// Add null check for $select
		if ($select) {
			$select.value = target.dataset.deliveryValue;
			$select.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}

	//get variant id
	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(
				this.querySelector('[type="application/json"]').textContent
			);
		return this.variantData;
	}

	//update options
	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll("select"),
			(select) => select.value
		);
	}

	getWeekNumbers(variant) {
		return parseInt(variant.option2.split("Week")[0]);
	}

	getPerDayPrice(variant) {
		const weekNumber = this.getWeekNumbers(variant);
		const perDayPrice = variant.price / 100 / (weekNumber * 7);

		const perWeekPrice = variant.price / 100 / weekNumber;

		const actualPrice = variant.price / 100;

		const priceHtml = this.generatePriceHtml(perWeekPrice, actualPrice);
		$("#product-form .inline-price span").html(priceHtml);

		$(`.shippedWeeksCount .weeks`).text(`${weekNumber} weeks`);
	}

	generatePriceHtml(perWeekPrice, actualPrice) {
		const discountPercentage = 20;
		const discountedPrice = perWeekPrice * (1 - discountPercentage / 100);
		return `
        <div class="priceSummery" data-actual-price=${actualPrice} data-applicable-price="${discountedPrice}" style="font-family: 'Satoshi'; display: inline-flex; align-items: baseline; gap: 5px;">
            <span style="font-weight: 700;text-decoration: line-through; color: #999; font-size: 24px !important">$${perWeekPrice.toFixed(
				2
			)}</span>
            <span style="font-weight: bold; font-size: 24px;">$${discountedPrice.toFixed(
				2
			)}<span style="font-size: 16px;">/week</span></span>
            <span style="font-size: 18px;margin-left: 10px;">(${discountPercentage}% first box discount)</span>
        </div>
    `;
	}

	//update master id
	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});

		if (this.prodSection.classList.contains("active-meal_form")) {
			this.getPerDayPrice(this.currentVariant);
		}
	}

	//generate and insert week option
generateWeekOption() {
    var drop_down_html = "",
        button_html = "",
        _this = this;

    const weekNumStyle = "font-family: 'Satoshi', sans-serif; font-weight: 800; font-size: 15px; color: #D36548; text-transform: uppercase;";
    const freshMealStyle = "font-family: 'Satoshi', sans-serif; font-weight: 400; font-size: 14px; color: #646464; margin-left: 5px;";
    const offTextStyle = "position: absolute; left: 10px; background: #1A2744; color: #FFFFFF; padding: 2px 7px; border-radius: 40px; font-size: 8px; font-weight: 900; font-family: 'Satoshi', sans-serif; white-space: nowrap; z-index: 10; text-transform: uppercase; letter-spacing: 0.5px;";

    if (this.totalVariants.length > 0) {
        // ✅ Duplicate delivery options hatao - unique option2 values rakho
        var seenOptions = [];
        var uniqueVariants = [];
        this.totalVariants.forEach(function(variant) {
            if (!seenOptions.includes(variant.option2)) {
                seenOptions.push(variant.option2);
                uniqueVariants.push(variant);
            }
        });

        uniqueVariants.forEach(function (variant, i) {
            var option2Val = variant.option2 || "";
            
            // ✅ Robust week number parsing
            var weekMatch = option2Val.match(/^(\d+)/);
            var weekNumber = weekMatch ? parseInt(weekMatch[1]) : 1;
            
            // ✅ week label - singular ya plural
            var week = weekNumber > 1 ? "WEEKS" : "WEEK";
            
            // ✅ Remaining text after "1 Week" or "2 Weeks" etc.
            var weekText = option2Val
                .replace(/^\d+\s*weeks?\s*/i, "")
                .trim() || "of Fresh Meals";

            const isSelected = (i == 0);
            const hasPromo = (weekNumber == 4);
            const promoHtml = hasPromo 
                ? `<div class="off_text" style="${offTextStyle}">Best Value</div>` 
                : "";

            button_html += `
                <div class="delivery-button ${isSelected ? 'selected-option' : ''}" 
                    data-weeks="${weekNumber}" 
                    data-delivery-value="${option2Val}"
                    style="display: flex; align-items: center; justify-content: center; padding: 10px 20px; 
                        border: 1.5px solid ${isSelected ? '#6B7D8F' : '#F3F4F5'}; 
                        border-radius: 12px; background: ${isSelected ? '#fff' : '#F3F4F5'}; 
                        cursor: pointer; position: relative; flex: 1; min-height: 40px; box-sizing: border-box;">
                    
                    ${promoHtml}
                    
                    <div style="display: flex; align-items: baseline; pointer-events: none;">
                        <span class="week-number-text" style="${weekNumStyle} ${!isSelected ? 'color: #344154;' : ''}">
                            ${weekNumber} ${week}
                        </span>
                        <span class="fresh-meals-text" style="${freshMealStyle}">
                            ${weekText}
                        </span>
                    </div>
                </div>`;

            drop_down_html += `<option value="${option2Val}" ${isSelected ? 'selected="selected"' : ''}>${option2Val}</option>`;
        });
    }

    return { drop_down_html, button_html };
}
	/**
	 * insert week options
	 */
	insertWeekOption() {
		this.totalVariants = this.getVariantData().filter((variant) => {
			return variant.option1 == this.options[0];
		});

		if (this.selectWeekOption) {
			var { drop_down_html, button_html } = this.generateWeekOption();
			if (drop_down_html) {
				this.selectWeekOption.innerHTML = drop_down_html;
				this.selectWeekOptionButton.innerHTML = button_html;
			}
		}
	}

	updateVariantInput() {
		const productForms = this.prodSection.querySelectorAll(
			`#product-form[formId="${this.dataset.section}"], #product-form-installment-${this.dataset.section}`
		);
		var _this = this;
		productForms.forEach(function (productForm) {
			const input = productForm.querySelector('input[name="id"]');
			input.value = _this.currentVariant.id;
		});

		this.getPerDayPrice(_this.currentVariant);
		// const price = _this.currentVariant
	}

	updatePickupAvailability() {
		const pickUpAvailability = this.prodSection.querySelector(
			"pickup-availability"
		);
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	removeErrorMessage() {
		const section = this.prodSection;
		if (!section) return;

		const productForm = section.querySelector("product-step-form");
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		var _this = this;

		fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				const destination = _this.prodSection.querySelector(
					`#price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				if (source && destination)
					destination.innerHTML = source.innerHTML;

				const price = _this.prodSection.querySelector(
					`#price-${this.dataset.section}`
				);

				if (price) price.classList.remove("visibility-hidden");
				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				);
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = this.prodSection.querySelector(
			`#product-form[formid="${this.dataset.section}"]`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			//addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			//addButton.removeAttribute("disabled");
			addButtonText.textContent = "Continue to Next Step";
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = this.prodSection.querySelector(
			`#product-form[formId="${this.dataset.section}"]`
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = this.prodSection.querySelector(
			`#price-${this.dataset.section}`
		);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add("visibility-hidden");
	}

	waitForElement(selector, trigger) {
		var interval = setInterval(function () {
			if (
				document &&
				document.querySelector(selector) &&
				document.querySelectorAll(selector).length > 0
			) {
				clearInterval(interval);
				trigger();
			}
		}, 50);
		setTimeout(function () {
			clearInterval(interval);
		}, 15000);
	}

	updateRechargeOptions() {
		var _this = this;

		//wait for option
		this.waitForElement('[name="selling_plan"] option', function () {
			var optionsm = _this.prodSection.querySelectorAll(
				'[name="selling_plan"] option'
			);
			var select = _this.prodSection.querySelector(
				'[name="selling_plan"]'
			);

			optionsm.length > 0 &&
				optionsm.forEach(function (option) {
					var inputWeek = _this.options[1];
					var optionText = option.innerText;
					if (!inputWeek || !optionText) return;
					if (inputWeek.includes("1") && optionText.includes("1")) {
						select.value = option.value;
					} else if (
						inputWeek.includes("2") &&
						optionText.includes("2")
					) {
						select.value = option.value;
					} else if (
						inputWeek.includes("4") &&
						optionText.includes("4")
					) {
						select.value = option.value;
					}
				});

			//dispatch select value
			select &&
				select.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}
}

customElements.define("variant-selects-opt", VariantSelectsOpt);
